// @flow
import React from 'react';
import {compose} from 'redux';
import {injectIntl, type IntlShape} from 'react-intl';

import './ResultsCount.less';
import resultsCountText from '../../utils/resultsCountText';

export type Shape = {
    from: number,
    to: number,
    total: number
};

export type Props = {
    resultsCount: Shape,
    intl: IntlShape
};

export const ResultsCount = (props: Props) => {
    let {
        resultsCount: {from, to, total},
        intl
    } = props;
    return (
        <div className="ResultsCount" data-wdio="ResultsCount">
            {resultsCountText(from, to, total, intl)}
        </div>
    );
};

export default compose(injectIntl)(ResultsCount);
